import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, space } from '../../theme/tokens';

export const CardBase = styled.div<{ $unavailable?: boolean; $clickable: boolean }>`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  cursor: ${({ $clickable, $unavailable }) =>
    $clickable ? ($unavailable ? 'not-allowed' : 'pointer') : 'default'};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.55 : 1)};
  transition: transform 0.2s ease;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: 12px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 12px;
  background: ${colors.lighterGrey};
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.grey};
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
`;

export const ImageBadge = styled.span`
  position: absolute;
  top: 12px;
  left: 12px;
  background: ${colors.sale};
  color: ${colors.white};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  padding: 4px 10px;
  border-radius: 4px;
  letter-spacing: 0.2px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
  padding: ${space[4]} 0 ${space[2]};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${space[3]};
`;

export const Title = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  margin: 0;
  line-height: 1.3;
  flex: 1;
  min-width: 0;
`;

export const Price = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  color: ${colors.fontPrimary};
  white-space: nowrap;
`;

export const Time = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
  margin-top: ${space[1]};
`;

export const Meta = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
`;

export const SpotsLeft = styled.span<{ $low: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${space[2]};
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $low }) => ($low ? colors.sale : colors.success)};
  }
`;

export const SoldOutBadge = styled.span`
  display: inline-block;
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  background: ${colors.lighterGrey};
  border-radius: 12px;
  padding: 2px 8px;
  align-self: flex-start;
`;
